export default __webpack_public_path__ + "static/ir-91abd9145c21e9a954806e32fc270360.svg";